import { chatEE } from '@/layout/events/chat-event-emitter';
import { cn } from '@/shared/utilities';
import { Card, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface MessageReactionsProps {
  isOwn?: boolean;
  className?: string;
  reactions?: Record<string, number> | null;
  conversationId: string;
  messageId: string;
  bucketId: string;
  messageContent: string;
}

export const MessageReactions = memo<MessageReactionsProps>(
  ({ isOwn = false, reactions, className, conversationId, messageId, bucketId, messageContent }) => {
    const { t } = useTranslation();
    if (!reactions || Object.keys(reactions).length === 0) return null;
    return (
      <Stack
        direction='row'
        gap={0.5}
        onClick={() => {
          chatEE.emit('show-message-reactions', {
            conversationId: conversationId,
            messageId: messageId,
            bucketId: bucketId,
            messageContent: messageContent
          });
        }}
        className={cn('mex:cursor-pointer mex:px-1', isOwn ? 'mex:ml-auto' : 'mex:mr-auto', className)}
        aria-label={t('messages.layout.messageContent')}
      >
        {Object.entries(reactions).map(([reaction, count]) => (
          <div
            key={reaction}
            className='mex:rounded-full mex:border-[1.5px] mex:border-white'
            style={{ minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <Card variant='outlined' className='mex:z-[99] mex:rounded-full mex:bg-white mex:p-0.2 mex:px-0.5'>
              <Typography variant='body2' className='mex:!text-[11px]'>
                {reaction} {count}
              </Typography>
            </Card>
          </div>
        ))}
      </Stack>
    );
  }
);
